import { createApp } from "vue";
import App from './presentation/App.vue';
import { GlobalsPlugin } from './vue-globals';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import {
	BodyEditorEvent,
	IEventPayloadRender,
	IEventPayloadRenderEditor,
	IEventPayloadRenderOverview,
} from '@studyportals/bodies-editor-integration';
import { PlatformIntegration } from './platform/PlatformIntegration';
import { StandAlone } from "./stand-alone/stand-alone";

const mount = (page: string, containerId: string): void => {
	const appProps = {
		page,
	};

	createApp(App, appProps)
		.use(GlobalsPlugin)
		.use(ElementPlus, { zIndex: 10 })
		.mount(containerId);
};

const preparePlatformIntegration = (payload: IEventPayloadRender): void => {
	PlatformIntegration.instance.context = payload.context;
	PlatformIntegration.instance.authorizer = payload.authorizer;
	PlatformIntegration.instance.router = payload.router;
	PlatformIntegration.instance.ui = payload.ui;
};

document.addEventListener(BodyEditorEvent.RENDER_EDITOR, (evt: unknown) => {
	const event = evt as CustomEvent<IEventPayloadRenderEditor>;

	preparePlatformIntegration(event.detail);
	mount('BodyEditor', event.detail.rootContainerId);
});

document.addEventListener(BodyEditorEvent.RENDER_OVERVIEW, (evt: unknown) => {
	const event = evt as CustomEvent<IEventPayloadRenderOverview>;

	preparePlatformIntegration(event.detail);
	mount('BodyOverview', event.detail.rootContainerId);
});


if (CONFIG.STAND_ALONE_LOGIN === 'true') {
	const standAlone = new StandAlone();

	standAlone.render();
}